<div class="relative">
       <app-input [label]="label"
              [(ngModel)]="value"
              [type]="'text'"
              [datepicker]="true"
              [optional]="optional"
              [owlDateTimeTrigger]="datepickerInstance"
              [autofocus]="autofocus"
              (keyupEnter)="toggleOpenClose($event)"
              (keyupBackspace)="backspace()"
              (blurred)="inputBlur()"
              (keydownTab)="inputTabKeyDown.emit()"
              [disable]="disable"
              [invalid]="control.errors"
              [errorMessage]="control.errors?.required ? 'This field is required': ''"
              class="datepicker-input-inner"
              [tabInd]="tabInd"
              [disableAutocomplete]="true"
              [id]="id"
              #appInput
       ></app-input>

       <img class="chevron" src="assets/icons/icon-chevron-down-gray.svg" alt="chevron"
              [ngClass]="{opened: isOpen}" (click)="toggleOpenClose($event)"/>

       <div class="owl-date-picker-container" [ngClass]="calendarPosition">
              <input class="datepicker-input"
                     (dateTimeChange)="datepickerChange($event)"
                     [owlDateTime]="datepickerInstance"
                     [min]="dateMin"
                     [max]="dateMax"
                     type="text"
                     [value]="dateTimeValue"
                     [selectMode]="selectMode"
              />
              <owl-date-time [panelClass]="panelClass"
                            [pickerType]="pickerType"
                            #datepickerInstance
                            (afterPickerOpen)="datepickerOpened()"
                            (afterPickerClosed)="datepickerClosed()"
                            (monthSelected)="setCorrectMinutes($event)"
                            (yearSelected)="setCorrectMinutes($event)"
              ></owl-date-time>
              <img class="icon" *ngIf="iconName"
                     [src]="'assets/icons/' + iconName + '.svg'" alt="date-picker-icon"/>
       </div>
</div>

